var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-dropdown',{attrs:{"options":_vm.mappedPumps,"value":_vm.pumpId},on:{"change":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }